/* Salaise Print Studio V8: Shopify Predictive Search API - standalone, no app */
(function(){
  'use strict';
  var pending = new WeakMap();
  var lastTrigger = null;
  var overlay = null;
  var minChars = 2;
  var locale = (document.documentElement.lang || 'fr-FR').replace('_','-');
  var currency = 'EUR';
  function routeRoot(){
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : root + '/';
  }
  function euro(v){
    var n = Number(v);
    if(!Number.isFinite(n)) return '';
    try{return new Intl.NumberFormat(locale,{style:'currency',currency:currency}).format(n);}
    catch(e){return n.toFixed(2)+' €';}
  }
  function safeLink(url){
    try {var parsed = new URL(url,location.origin);return parsed.origin===location.origin? parsed.pathname+parsed.search+parsed.hash:'';}catch(e){return '';}
  }
  function imageUrl(url){
    try{var parsed=new URL(url,location.origin);if(parsed.protocol==='https:' || (parsed.protocol==='http:' && parsed.origin===location.origin)) return parsed.href;}catch(e){}
    return '';
  }
  function elt(tag,cls,txt){var e=document.createElement(tag);if(cls)e.className=cls;if(txt!=null)e.textContent=txt;return e;}
  function hide(state){
    state.panel.hidden=true;
    state.input.setAttribute('aria-expanded','false');
    state.options=[];
    state.selected=-1;
  }
  function show(state){state.panel.hidden=false;state.input.setAttribute('aria-expanded','true');}
  function option(state,href,cls,content){
    var path=safeLink(href);if(!path)return null;
    var a=elt('a',cls);a.href=path;
    content(a);state.options.push(a);return a;
  }
  function makeItem(state,p){
    var a=option(state,p.url,'sps-predictive-results__item',function(a){
      var th=elt('span','sps-predictive-results__thumb');
      var image=imageUrl(p.image || (p.featured_image && p.featured_image.url));
      if(image){var img=elt('img');img.src=image;img.loading='lazy';img.alt='';th.appendChild(img);}else{th.textContent='◻';}
      var content=elt('span','sps-predictive-results__body');
      content.appendChild(elt('span','sps-predictive-results__title',p.title));
      var price=euro(p.price);if(price)content.appendChild(elt('span','sps-predictive-results__price',price));
      a.appendChild(th);a.appendChild(content);
    });
    return a;
  }
  function appendSection(state,heading,entries,make){
    if(!entries||!entries.length)return;
    state.panel.appendChild(elt('p','sps-predictive-results__heading',heading));
    var ul=elt('ul','sps-predictive-results__list');
    entries.forEach(function(entry){var a=make(entry);if(!a)return;var li=elt('li');li.appendChild(a);ul.appendChild(li);});
    state.panel.appendChild(ul);
  }
  function build(state,data,term){
    var results=(data&&data.resources&&data.resources.results)||{};
    var products=(results.products||[]).slice(0,6);
    var collections=(results.collections||[]).slice(0,3);
    state.panel.textContent='';state.options=[];state.selected=-1;
    if(!products.length && !collections.length){
      state.panel.appendChild(elt('p','sps-predictive-results__state','Aucun résultat suggéré. Essayez un autre terme ou consultez la recherche complète.'));
    } else {
      appendSection(state,'Produits',products,function(p){return makeItem(state,p);});
      appendSection(state,'Collections',collections,function(c){return option(state,c.url,'sps-predictive-results__collection',function(a){a.textContent=c.title;});});
    }
    var q=encodeURIComponent(term);
    var all=option(state,routeRoot()+'search?type=product&q='+q,'sps-predictive-results__footer',function(a){a.textContent='Voir tous les résultats pour « '+term+' » →';});
    if(all)state.panel.appendChild(all);
    show(state);
  }
  function load(state){
    clearTimeout(state.timer);
    if(state.controller)state.controller.abort();
    var term=state.input.value.trim();
    if(term.length<minChars){hide(state);state.status.textContent='';return;}
    state.timer=setTimeout(function(){
      var controller=new AbortController();state.controller=controller;
      state.status.textContent='Recherche en cours';
      var url=routeRoot()+'search/suggest.json?q='+encodeURIComponent(term)+'&resources%5Btype%5D=product%2Ccollection&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      fetch(url,{signal:controller.signal,headers:{'Accept':'application/json'}})
        .then(function(response){if(!response.ok)throw new Error('Search '+response.status);return response.json();})
        .then(function(data){if(state.controller!==controller||state.input.value.trim()!==term)return;build(state,data,term);state.status.textContent='Suggestions disponibles';})
        .catch(function(err){if(err.name==='AbortError')return;hide(state);state.status.textContent='Suggestions indisponibles. Appuyez sur Entrée pour rechercher.';});
    },240);
  }
  function initForm(form,index){
    if(form.dataset.spsReady)return;
    var input=form.querySelector('input[name="q"]');if(!input)return;
    form.dataset.spsReady='true';form.classList.add('sps-predictive-form');
    var id='sps-predictive-panel-'+index;
    var panel=elt('div','sps-predictive-results');panel.id=id;panel.hidden=true;panel.setAttribute('role','group');panel.setAttribute('aria-label','Suggestions de recherche');
    var status=elt('div','sps-sr-only');status.setAttribute('role','status');status.setAttribute('aria-live','polite');
    input.setAttribute('aria-controls',id);input.setAttribute('aria-expanded','false');input.setAttribute('aria-haspopup','true');input.setAttribute('autocomplete','off');
    form.appendChild(panel);form.appendChild(status);
    var state={form:form,input:input,panel:panel,status:status,options:[],selected:-1,timer:null,controller:null};
    pending.set(form,state);
    input.addEventListener('input',function(){load(state);});
    form.addEventListener('keydown',function(e){
      if(e.key==='Escape'){hide(state);state.input.focus();return;}
      if((e.key==='ArrowDown'||e.key==='ArrowUp')&&!panel.hidden&&state.options.length){
        e.preventDefault();
        state.selected=(state.selected+(e.key==='ArrowDown'?1:-1)+state.options.length)%state.options.length;
        state.options[state.selected].focus();
      }
    });
    form.addEventListener('focusout',function(e){
      if(!form.contains(e.relatedTarget)){setTimeout(function(){if(!form.contains(document.activeElement))hide(state);},110);}
    });

  }
  function open(){
    if(!overlay)return;
    lastTrigger=document.activeElement;
    overlay.style.display='block';document.body.classList.add('sps-search-open');
    setTimeout(function(){var input=overlay.querySelector('input[name="q"]');if(input)input.focus();},30);
  }
  function close(){
    if(!overlay)return;
    overlay.style.display='none';document.body.classList.remove('sps-search-open');
    overlay.querySelectorAll('form[data-sps-predictive]').forEach(function(f){var s=pending.get(f);if(s){if(s.controller)s.controller.abort();hide(s);}});
    if(lastTrigger&&typeof lastTrigger.focus==='function')lastTrigger.focus();
  }
  function init(){
    overlay=document.getElementById('search-overlay');
    if(overlay){
      window.openSearch=open;window.closeSearch=close;
      var btn=overlay.querySelector('[data-sps-search-close]');if(btn)btn.addEventListener('click',close);
      overlay.addEventListener('click',function(e){if(e.target===overlay)close();});
      document.addEventListener('keydown',function(e){
        if(overlay.style.display!=='block')return;
        if(e.key==='Escape'){e.preventDefault();close();return;}
        if(e.key!=='Tab')return;
        var focusable=Array.from(overlay.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])'))
          .filter(function(el){return el.getClientRects().length>0;});
        if(!focusable.length)return;
        var first=focusable[0],last=focusable[focusable.length-1];
        if(e.shiftKey && (document.activeElement===first || !overlay.contains(document.activeElement))){e.preventDefault();last.focus();}
        else if(!e.shiftKey && (document.activeElement===last || !overlay.contains(document.activeElement))){e.preventDefault();first.focus();}
      });
    }
    document.querySelectorAll('form[data-sps-predictive]').forEach(initForm);
    document.addEventListener('click',function(e){document.querySelectorAll('form[data-sps-predictive]').forEach(function(f){if(!f.contains(e.target)){var s=pending.get(f);if(s)hide(s);}});});
    document.addEventListener('shopify:section:load',function(){document.querySelectorAll('form[data-sps-predictive]').forEach(initForm);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
